const ge = {
	login: 'Einloggen',
	logout: 'Ausloggen',
	signin: 'Einloggen',
	signup: 'Anmelden',
	email: 'Email',
	emailAddr: 'E-Mail-Addresse',
	password: 'Passwort',
	rememberMe: 'Behalte mich in Erinnerung',
	forgotYourPwd: 'Passwort vergessen?',
	signinFacebook: 'Mit Facebook anmelden',
	signinGoogle: 'Anmeldung mit Google',
	dontAccount: 'Sie haben noch keinen Account?',
	firstName: 'Vorname',
	lastName: 'Familienname, Nachname',
	confirmPwd: 'Bestätige das Passwort',
	signup_msg: 'Wenn Sie auf Jetzt beitreten klicken, stimmen Sie dem zu',
	digitX_user_agreement: 'DigitXchange-Benutzervereinbarung',
	privacy_policy: 'Datenschutz-Bestimmungen',
	and: ' und ',
	cookies_policy: 'Cookie-Richtlinie',
	have_account: 'Sie haben bereits ein Konto',
	forgotPwd: 'Passwort vergessen',
	recoverPwd: 'PASSWORT WIEDERHERSTELLEN',
	forgotPwd_msg: 'Geben Sie Ihre E-Mail-Adresse in das Feld oben ein. Wir senden Ihnen einen Link mit den folgenden Anweisungen.',
	changePwd: 'Ändere das Passwort',
	oldPwd: 'Altes Passwort',
	newPwd: 'Neues Kennwort',
	confirmNewPwd: 'Bestätige neues Passwort',
	user_account: 'Benutzerkonto',
	change_pic: 'Bild ändern',
	mobile_number: 'Handynummer',
	country: 'Land',
	update_settings: 'Update Einstellungen',
	company: 'Unternehmen',
	aboutUs: 'Über uns',
	tos: 'TOS',
	copyright: 'Urheberrechte ©',
	socialMedia: 'Sozialen Medien',
	forUpdates: 'für Updates',
	footer_msg_1: 'Mit Ihrer Anmeldung akzeptieren Sie',
	terms: 'Nutzungsbedingungen',
	contactUs: 'Kontaktiere uns',
	yourEmail: 'Deine E-Mail',
	required: 'erforderlich',
	yourMsg: 'Deine Nachricht',
	sent: 'Geschickt',
	footer_msg_2: 'Alle Rechte vorbehalten',
	footer_msg_3: 'Alle Produktnamen, Marken und eingetragenen Marken sind Eigentum ihrer jeweiligen Inhaber',
	doom: 'Untergang III',
	filter: 'Filter',
	add_asset: 'Asset hinzufügen',
	request_game: 'Spiel anfordern',
	search_msg: 'Entschuldigung, aber nichts stimmte mit Ihren Suchbegriffen überein.',
	post: 'Post',
	asset: 'Anlagegut',
	create: 'Erstellen',
	character: 'Charakter',
	characters: 'Figuren',
	assets: 'Vermögenswerte',
	profile: 'Profil',
	game: 'Spiel',
	games: 'Spiele',
	currency: 'Währung',
	store: 'Geschäft',
	all_time: 'Alle Zeit',
	this_month: 'Diesen Monat',
	trending: 'Trend',
	item_name: 'Artikelname',
	view_item: 'Element anzeigen',
	leaderboard: 'Bestenliste',
	posters: 'Plakate',
	chinese: 'Chinesisch',
	english: 'Englisch',
	japanese: 'japanisch',
	korean: 'Koreanisch',
	german: 'Deutsche',
	french: 'Französisch',
	spanish: 'Spanisch',
	italian: 'Italienisch',
	russian: 'Russisch',
	portuguese: 'Portugiesisch',
	hindi: 'Hindi',
	arabic: 'Arabisch',
	buy: 'Kaufen',
	subscription: 'Abonnement',
	buy_subscription: 'Abonnement kaufen',
	gift: 'Geschenk',
	xchange: 'Xchange',
	subscription_plan: 'Abonnementplan',
	payment_options: 'Zahlungsmöglichkeiten',
	cardholder_name: 'Name des Karteninhabers',
	submit_order: 'Bestellung abschicken',
	card_number: 'Kartennummer',
	cvv: 'CVV',
	expiration_date: 'Haltbarkeitsdatum',
	buyXchange: 'Xchange kaufen',
	giftXchange: 'Geschenk Xchange',
	or: 'oder',
	select: 'Wählen',

	search: 'Suche',
	search_games: 'Suchspiele ...',
	search_assets: 'Assets suchen ...',
	platform: 'Plattform',
	total_posts: 'Beiträge insgesamt',
	total_comments: 'Kommentare insgesamt',
	total_characters: 'Gesamtzahl der Zeichen',
	total_assets: 'Gesamtvermögen',
	xchange_currency: 'Xwährung ändern',
	subscription_days_remaining: 'Verbleibende Abonnementtage',
	total_asset_networth: 'Gesamtvermögen Networth',
	total_character_networth: 'Gesamtcharakter Networth',
	most_downloaded: 'Am meisten heruntergeladen',
	recently_added: 'Kürzlich hinzugefügt',
	genre: 'Genre',
	my_library: 'Meine Bibliothek',
	most_commented: 'am meisten kommentiert',
	most_recent: 'Neueste',
	nearing_addition: 'Kurz vor der Hinzufügung',
	create_asset: 'Asset erstellen',
	create_character: 'Charakter erstellen',
	asset_name: 'Asset-Name',
	asset_type: 'Asset-Typ',
	rarity: 'Seltenheit',
	enhancements: 'Verbesserungen',
	add: 'Hinzufügen',
	currency_type: 'Währungstyp',
	price: 'Preis',
	description: 'Beschreibung',
	upload_asset: 'Asset hochladen',
	preview_asset: 'Vorschau des Assets',
	main_image: 'Hauptbild',
	upload_video: 'Video hochladen',
	upload: 'Hochladen',
	view_demo: 'Demo anzeigen',
	character_name: 'Charaktername',
	character_type: 'Zeichentyp',
	upload_character: 'Zeichen hochladen',
	preview_character: 'Vorschau Charakter',
	race: 'Rennen',
	class: 'Klasse',
	gender: 'Geschlecht',
	level: 'Niveau',
	showing: 'Zeigen',
	of: 'von',
	results: 'Ergebnisse',
	featured_characters: 'Ausgewählte Charaktere',
	url: 'URL',
	submit: 'einreichen',
	real_world: 'Echte Welt',
	game_currency: 'Spielwährung',
	all: 'Alle',

	edit: 'Bearbeiten',
	save: 'sparen',
	agg_character_networth: 'Aggregierter Charakter Networth',
	agg_time_played: 'Aggregierte Spielzeit',
	agg_asset_value: 'Aggregierter Vermögenswert',
	enter_character_creation_date: 'Geben Sie das Erstellungsdatum des Charakters ein',
	in_game_currency: 'In Spielwährung',
	real_world_value: 'Wert der realen Welt',
	update_character: 'Charakter aktualisieren',
	item_not_found: 'Artikel nicht gefunden!',
	ripper: 'Aufreißer',
	comments: 'Bemerkungen',
	add_comments: 'Füge Kommentare hinzu',
	new_suggested_price: 'Neuer empfohlener Preis',
	sort_by: 'Sortiere nach',
	reply: 'Antworten',
	asset_networth: 'Asset Networth',
	join_date: 'Beitrittsdatum',
	report: 'Bericht',
	first: 'Zuerst',
	last: 'Zuletzt',
	most_replies: 'Die meisten Antworten',
	new_pricing_recommendations: 'Neue Preisempfehlungen',
	xchange_amount: 'Xchange-Betrag',
	username: 'Nutzername',
	send_gift: 'Geschenk senden',
	message: 'Botschaft',
	gift_text: 'Personalisieren Sie Ihre Nachricht hier',
	day: 'Tag',
	days: 'Tage',
	currency_converter: 'Währungsrechner',
	from: 'Von',
	to: 'Zu',
	in_game: 'Im Spiel',
	real_life: 'Wahres Leben',
	cvc: 'CVC',
	card: 'Karte',
	per_month: 'Monatlich (3 USD pro Monat)',
	per_year: 'Jährlich (30 USD pro Jahr)',
	aboutUs_text: 'DigitXChange ist eine Community-gesteuerte Website, die darauf abzielt, den Wert digitaler Waren und Dienstleistungen durch Crowd-Sourcing endlich zu bewerten. Wenn Sie jemals die Frage gestellt haben, "wie viel ist mein Charakter tatsächlich wert" oder "Ich frage mich, was ein fairer Handel mit einem anderen Spieler in einem anderen Spiel wäre", suchen Sie nicht weiter nach Antworten. Wir hoffen, dass Sie unsere Website genießen, am Aufbau des Gruppenwissens teilnehmen, Ihre hart verdiente Beute vorführen und sich letztendlich darauf freuen, Ihr gesamtes digitales Vermögen herauszufinden!',
	home: 'Startseite',
	all_time_characters: 'Alle Zeitzeichen',
	this_month_characters: 'Diesen Monat Charaktere',
	trending_characters: 'Trendzeichen',
	all_time_posters: 'Alle Zeit Poster',
	this_month_posters: 'Diesen Monat Poster',
	trending_posters: 'Trendplakate',

};

export default ge;


// WEBPACK FOOTER //
// ./src/translations/ge.js